"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationVariables = exports.AnimationStyles = void 0;
var theme_1 = require("@fluentui/theme");
Object.defineProperty(exports, "AnimationStyles", { enumerable: true, get: function () { return theme_1.AnimationStyles; } });
Object.defineProperty(exports, "AnimationVariables", { enumerable: true, get: function () { return theme_1.AnimationVariables; } });
//# sourceMappingURL=AnimationStyles.js.map